import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET: (taskId) => ({ taskId }),
    API: {
      GET: apiResourceActionCreator('task')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${payload.taskId}`, authToken, actions.task.api.get);

function* get(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'get',
  action: actions,
  sagas: get,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      task: action.payload.task,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/get.js